module.exports = __webpack_public_path__ + "static/media/letter_n.f1ffd463.m4a";